import { createSagotClient } from "@sagot/api-client";
import { API_URL, DEFAULT_API_BASE_URL } from "@sagot/constants";

/** Workspace bound to this tab (`/w/:ws` → id); sent as `X-Workspace-Id` on every console call. */
let activeWorkspaceId: string | null = null;

export function setActiveWorkspaceId(id: string | null): void {
  activeWorkspaceId = id;
}

export function getActiveWorkspaceId(): string | null {
  return activeWorkspaceId;
}

export const consoleClient = createSagotClient({
  realm: "console",
  baseUrl: API_URL ?? DEFAULT_API_BASE_URL,
  getWorkspaceId: getActiveWorkspaceId,
  // No CSRF cookie means no session: skip the boot refresh the browser would log as a 403 console error on every auth page.
  skipRefreshWithoutCsrf: true,
});

export const api = consoleClient.api;
